import React from 'react';

import { ModalComponent } from 'baseComponents/ModalComponent';
import { TabsComponent } from 'baseComponents/TabsComponent';
import { GSM7Table } from 'screens/CreateCampaignScreen/components/GSM7Table';
import { UCS2Table } from 'screens/CreateCampaignScreen/components/UCS2Table';

import './referenceTablesModal.scss';
const _ = require('lodash');
interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  referenceTablesData: any;
}

export const ReferenceTablesModal: React.FC<Props> = (props) => {
  const GSM7 = _.find(props.referenceTablesData, { encoding: 'GSM-7' });
  const UCS2 = _.find(props.referenceTablesData, { encoding: 'UCS-2' });
  const tabsContent = [
    {
      label: 'GSM-7 ENCODING',
      key: 'GSM-7ENCODING',
      children: <GSM7Table data={GSM7?.data || []} />,
    },
    {
      label: 'UCS-2 ENCODING',
      key: 'UCS-2ENCODING',
      children: <UCS2Table data={UCS2?.data || []} />,
    },
  ];

  return (
    <ModalComponent
      title='Reference tables'
      close={props.closeModal}
      open={props.isModalOpen}
    >
      <div className='modal-content-wrapper'>
        <TabsComponent onChange={() => {}} items={tabsContent} />
      </div>
    </ModalComponent>
  );
};
